import locationIcon from "./assets/locationn.png";
import fulltimeIcon from "./assets/fulltime-icon.png";
import experienceIcon from "./assets/experience-icon.png";

const JobInformation = () => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm max-w-sm w-full">
      <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
        Job Information
      </h2>

      <div className="space-y-4">
        {/* Location */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img
            src={locationIcon}
            alt="Location Icon"
            className="w-12 h-12 mr-4"
          />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Location</p>
            <p className="text-[#111827] text-base font-semi">Chennai</p>
          </div>
        </div>

        {/* Job Type */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img
            src={fulltimeIcon}
            alt="Job Type Icon"
            className="w-12 h-12 mr-4"
          />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Job type</p>
            <p className="text-[#111827] text-base font-semi">Full time</p>
          </div>
        </div>

        {/* Experience */}
        <div className="flex items-center bg-[#F9FAFB] p-4 rounded-xl">
          <img
            src={experienceIcon}
            alt="Experience Icon"
            className="w-12 h-12 mr-4"
          />
          <div>
            <p className="text-[#9CA3AF] text-sm font-medium">Experience</p>
            <p className="text-[#111827] text-base font-semi">Fresher</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobInformation;
